// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/items_to_reorder_report.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ItemsToReorderItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ItemsToReorderReportRequest
 */
export class ItemsToReorderReportRequest extends Message<ItemsToReorderReportRequest> {
  /**
   * Page number for pagination
   *
   * @generated from field: int32 page_number = 1;
   */
  pageNumber = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<ItemsToReorderReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ItemsToReorderReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ItemsToReorderReportRequest {
    return new ItemsToReorderReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ItemsToReorderReportRequest {
    return new ItemsToReorderReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ItemsToReorderReportRequest {
    return new ItemsToReorderReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ItemsToReorderReportRequest | PlainMessage<ItemsToReorderReportRequest> | undefined, b: ItemsToReorderReportRequest | PlainMessage<ItemsToReorderReportRequest> | undefined): boolean {
    return proto3.util.equals(ItemsToReorderReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ItemsToReorderReportResponse
 */
export class ItemsToReorderReportResponse extends Message<ItemsToReorderReportResponse> {
  /**
   * List of items to reorder
   *
   * @generated from field: repeated com.neulink.pharmacy.ItemsToReorderItem items_to_reorder = 1;
   */
  itemsToReorder: ItemsToReorderItem[] = [];

  /**
   * Total number of items available
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ItemsToReorderReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ItemsToReorderReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items_to_reorder", kind: "message", T: ItemsToReorderItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ItemsToReorderReportResponse {
    return new ItemsToReorderReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ItemsToReorderReportResponse {
    return new ItemsToReorderReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ItemsToReorderReportResponse {
    return new ItemsToReorderReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ItemsToReorderReportResponse | PlainMessage<ItemsToReorderReportResponse> | undefined, b: ItemsToReorderReportResponse | PlainMessage<ItemsToReorderReportResponse> | undefined): boolean {
    return proto3.util.equals(ItemsToReorderReportResponse, a, b);
  }
}

